import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-base-gray-100 dark:bg-base-gray-800", className)}
      {...props}
    />
  )
}

export { Skeleton }